// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"3514644c","432":"75dac2fd"}[chunkId] + ".chunk.css";
};